import { render } from "./StaffUpload.vue?vue&type=template&id=d7ae2bda&scoped=true"
import script from "./StaffUpload.vue?vue&type=script&lang=js"
export * from "./StaffUpload.vue?vue&type=script&lang=js"

import "./StaffUpload.vue?vue&type=style&index=0&id=d7ae2bda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7ae2bda"]])

export default __exports__